module.exports = __webpack_public_path__ + "66cb0cd9e54d34e883f1413fe7897c17.svg";